<template>
  <div>
    <a-form layout="inline" :model="searchForm" style="margin-bottom:16px;" labelAlign="right" :labelCol="{flex: '90px'}">
      <div class="search-grid">
        <a-form-item label="操作人员"><a-input v-model:value="searchForm.operator" placeholder="请输入操作人员名称查询" /></a-form-item>
        <a-form-item label="用户ID"><a-input v-model:value="searchForm.userId" placeholder="请输入用户ID查询" /></a-form-item>
        <a-form-item label="操作名称"><a-input v-model:value="searchForm.actionName" placeholder="请输入操作名称查询" /></a-form-item>
        <a-form-item label="业务类型"><a-select v-model:value="searchForm.bizType" placeholder="请选择业务类型" allow-clear>
          <a-select-option value="查询">查询</a-select-option>
          <a-select-option value="修改">修改</a-select-option>
        </a-select>
        </a-form-item>
        <a-form-item label="应用编号"><a-input v-model:value="searchForm.appCode" placeholder="请输入应用编号查询" /></a-form-item>
        <a-form-item style="grid-column:span 2;display:flex;align-items:center;">
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left:8px" @click="handleReset">重置</a-button>
        </a-form-item>
      </div>
    </a-form>
    <a-table :columns="columns" :data-source="logList" row-key="id" :pagination="{pageSize:10}" />
  </div>
</template>
<style scoped>
.search-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 16px;
  align-items: center;
}
</style>
<script setup>
import { ref } from 'vue';
const searchForm = ref({ operator: '', userId: '', actionName: '', bizType: '', appCode: '' });
const columns = [
  { title: '操作时间', dataIndex: 'actionTime', key: 'actionTime' },
  { title: '操作名称', dataIndex: 'actionName', key: 'actionName' },
  { title: '业务类型', dataIndex: 'bizType', key: 'bizType' },
  { title: '操作人员名称', dataIndex: 'operator', key: 'operator' },
  { title: '用户ID', dataIndex: 'userId', key: 'userId' },
  { title: '操作主机IP地址', dataIndex: 'hostIp', key: 'hostIp' },
  { title: '操作地点', dataIndex: 'location', key: 'location' },
  { title: '应用编号', dataIndex: 'appCode', key: 'appCode' },
  { title: '状态码', dataIndex: 'status', key: 'status',
    customRender: ({text}) => text === '成功' ? '🟢 成功' : '🔴 失败' },
  { title: '操作', key: 'action',
    customRender: () => '<a-button type="link">详情</a-button>' }
];
const logList = ref([
  { id: 1, actionTime: '2025-05-07 13:05', actionName: '获取登录日志列表', bizType: '查询', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 2, actionTime: '2025-05-07 13:05', actionName: '更新用户配置', bizType: '修改', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 3, actionTime: '2025-05-07 12:29', actionName: '获取登录日志列表', bizType: '查询', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 4, actionTime: '2025-05-07 12:29', actionName: '更新用户配置', bizType: '修改', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 5, actionTime: '2025-05-07 10:49', actionName: '更新用户配置', bizType: '修改', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 6, actionTime: '2025-05-07 10:49', actionName: '获取专业详情列表', bizType: '查询', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 7, actionTime: '2025-05-07 10:48', actionName: '获取存费详情列表', bizType: '查询', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 8, actionTime: '2025-05-07 10:48', actionName: '获取专业详情列表', bizType: '查询', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' },
  { id: 9, actionTime: '2025-05-07 10:48', actionName: '获取存费详情列表', bizType: '查询', operator: 'administrator', userId: '1740358057038188544', hostIp: '172.20.0.1', location: '', appCode: 'core', status: '成功' }
]);
function handleSearch() { /* 可根据searchForm过滤logList */ }
function handleReset() { searchForm.value = { operator: '', userId: '', actionName: '', bizType: '', appCode: '' }; }
</script>